import {action, observable} from "mobx";
import {NoticeTypeEnum} from "../models/notice";
import {ISysOption, SysOptionEnum} from "../models/sys/sys-option";
import {ViewEnum} from "../models/view";
import SimpleStore from "./base/simple-store";
import RootStore from "./root-store";

export default class SysStore extends SimpleStore {

    @observable
    public options: ISysOption[];

    @observable
    public aboutTexts: string[];

    @observable
    public homeTexts: string[];

    constructor(rootStore: RootStore) {
        super(rootStore);
    }

    public async getOptions() {
        if (!this.options && !this.isFetching) {
            try {
                this.startFetching();
                const result = await this.rootStore.sysApi.getOptions();
                this.setOptions(result.data);
            } catch (e) {
                this.notify(NoticeTypeEnum.Failure, e);
            } finally {
                this.finishFetching();
            }
        }
    }

    public getOptionByName(name: SysOptionEnum): string {
        return this.options && this.options.find(option => option.name === name).value;
    }

    public async getTextsByView(view: ViewEnum) {
        try {
            this.startFetching();
            const result = await this.rootStore.sysApi.getTextsByView(view);
            this.setTexts(result.data, view);
        } catch (e) {
            this.notify(NoticeTypeEnum.Failure, e);
        } finally {
            this.finishFetching();
        }
    }

    @action
    private setTexts(texts: string[], view: ViewEnum) {
        switch (view) {
            case ViewEnum.About:
                this.aboutTexts = texts;
                break;
            case ViewEnum.Home:
                this.homeTexts = texts;
        }
    }

    @action
    private setOptions(options: ISysOption[]) {
        this.options = options;
    }
}



// WEBPACK FOOTER //
// ./src/stores/sys-store.ts